import { ImageTypes } from "~enums/imageTypes";

type Props = {
  person: Person;
};

import type { Person } from "~types/person";
import { findImageByType } from "~utilities/findImageByType";

const PersonColumn = ({ person }: Props) => {
  const personLogoUrl = findImageByType(person?.images, ImageTypes.PersonHead);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      {person &&
        (personLogoUrl ? (
          <img alt="Person avatar" src={personLogoUrl} width={25} height={25} />
        ) : (
          <i style={{ width: 25 }} className="fas fa-shield fa-xl" />
        ))}
      <span>{person?.nameFullLocal}</span>
    </div>
  );
};
export default PersonColumn;
